import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Grid, List, Image, Table, Icon } from 'semantic-ui-react'
import { useHistory } from "react-router-dom";
import moment from "moment";
import "./ContestLandingScreen.scss";
import { Config } from "../../common"
import calendar from "../../assets/home/calendar.png";
import rupees from "../../assets/home/rupees.png";
import handimg from "../../assets/animation_button.gif";
import { useSelector, useDispatch } from 'react-redux'
import { setTriviaInfo, detailAllTrivias } from '../../store/TriviaRedux'
import { setLoginRedirectUrl } from '../../store/AuthRedux'
import OrderHistory from "../../components/OrderHistory";
import { useTranslation } from "react-i18next";
import Countdown from 'react-countdown';
import { StarButton, Loading } from '../../components'

const ContestLandingScreen = (props) => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const singleTrivias = useSelector((state) => state.trivia.singleTrivias)
  const isFetching = useSelector((state) => state.trivia.isFetching)
  const { match } = props;
  const [showhistory, setShowhistory] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  useEffect(() => {
    if (match.params.id) {
      dispatch(detailAllTrivias({ id: match.params.id, token }))
    }
  }, [match]);
  
  const enterContest = () => {
    if (token && singleTrivias) {
      dispatch(setTriviaInfo(singleTrivias))
      history.push("/payment");
    } else {
      dispatch(setLoginRedirectUrl(`landing/${match.params.id}`))
      history.push("/login");
    }
  };


  const renderer = ({ days, hours, minutes, seconds }) => {
    return <div className="calender_sec clearall">
      <div className="carryminer">
        <h3>{days}</h3>
        <p>DAY(S)</p>
      </div>
      <div className="dot_sec">:</div>
      <div className="carryminer">
        <h3>{hours}</h3>
        <p>HOUR(S)</p>
      </div>
      <div className="dot_sec">:</div>
      <div className="carryminer">
        <h3>{minutes}</h3>
        <p>MINUTE(S)</p>
      </div>
    </div>
  };

  if (isFetching) {
    return <Loading />
  }

  let newDate = singleTrivias.endDate ? moment.utc(singleTrivias.endDate) - moment.utc(Config.localUtc()) : null
  let basicDetails = singleTrivias ? Config.GetLanguage(singleTrivias, i18n.language, 'basicDetails') : {}
  let title = basicDetails?.title ? basicDetails?.title : null
  let rules = singleTrivias ? Config.GetLanguage(singleTrivias, i18n.language, 'rules') : []
  return (
    <>
      <div className="container-fluid main-div  clearall">
        <Grid divided='vertically'>
          <Grid.Row columns={2}>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <img className="destops bitmap landing-star" src={singleTrivias?.landingImage} />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <div className="printing clearall">
                <div className="lorem_ipsum">
                  {title && (<h1>{(title).split(' ')[0]} <span> {title.substring(title.indexOf(" ") + 1, title?.length)}</span></h1>)}
                  <p>{basicDetails.about}</p>
                  <img className="star_1" src={singleTrivias?.landingMobileViewImage} />
                </div>
                <Grid columns={2} >
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <div className="list_sec">
                      <List horizontal>
                        <List.Item>
                          <Image className="calendars" src={calendar} />
                          <List.Content>
                            <List.Header className="listheader">Contest Dates</List.Header>
                            <List.Description className="description">
                              {moment.utc(singleTrivias?.startDate).format('Do MMM YYYY')} - {moment.utc(singleTrivias?.endDate).format('Do MMM YYYY')}
                            </List.Description>
                          </List.Content>
                        </List.Item>
                      </List>
                    </div>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <div className="list_screen">
                      <List horizontal>
                        <List.Item>
                          <Image className="calendars" src={rupees} />
                          <List.Content>
                            <List.Header className="listheader">Contest Fees</List.Header>
                            <List.Description>
                              {singleTrivias?.entryFee}
                            </List.Description>
                          </List.Content>
                        </List.Item>
                      </List>
                    </div>
                  </Grid.Column>
                </Grid>

                <h5 className="contest_ends clearall">CONTEST ENDS IN</h5>

                <Countdown date={Date.now() + newDate}
                  renderer={renderer}
                />
                <div className="registration">
                  <i className="fa fa-circle" aria-hidden="true"></i> <span>{singleTrivias?.players?.length} Active Participations</span>
                </div>
                <div className="contestsHome clearall">
                  <div className="contests_sec">
                    <StarButton background={'mainBg'} title={t("contest.btn")} onClickAction={() => enterContest()} />
                  </div>
                  <button className="enter_btn" onClick={() => {
                    window.scrollTo(0, 1500)
                    setShowhistory(!showhistory)
                  }}><img className="img1" src={handimg} /><span>View Entries</span><img className="img2" src={handimg} /></button>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>



        <div className="overview">How to <span> Win</span></div>
        {singleTrivias && singleTrivias.rules && (
          <>
            {rules.map((item, key) => <div key={key} className="Rule">
              <div className="Rules">
                <h5>{key + 1}. {item}</h5>
              </div>
            </div>)}
          </>
        )}

        {(token && showhistory) ? <>
          <div className="entries">
            <h5>{t("landing.titel1")} <span>{t("landing.titel2")} </span></h5>
            <p>{t("landing.para")}</p>
          </div>
          <OrderHistory contestid={match.params.id} singleTrivias={singleTrivias} />
        </> : null}
      </div>
    </>
  );
};

export default ContestLandingScreen